import { render, staticRenderFns } from "./SearchProspects.vue?vue&type=template&id=2fc0cf0f&"
import script from "./SearchProspects.vue?vue&type=script&lang=js&"
export * from "./SearchProspects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports